var richerfilms = new function () {
    this.sizes = {
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 320,
        xs: 0
    };
    this.xhr;
    this.getCookie = function (cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    this.setSlickInit = function ($element, event, slick) {
        if (typeof $element.data('slickPageNumber') != 'undefined') {
            $element.before('<div class="slick-page-number"></div>');
            var $pageNumber = $element.parent().find('.slick-page-number');
            if ($pageNumber.length) {
                var totalPages = Math.ceil(slick.slideCount / slick.slickGetOption('slidesToShow'));
                if (totalPages > 1) {
                    $pageNumber.html('<span class="current">1</span>/' + totalPages);
                } else {
                    $pageNumber.html('');
                }
            }
        }
    };
    this.setSlickBeforeChange = function ($element, event, slick, currentSlide, nextSlide) {
        var $pageNumber = $element.parent().find('.slick-page-number');
        if ($pageNumber.length) {
            var totalPages = Math.ceil(slick.slideCount / slick.slickGetOption('slidesToShow')),
                pageNumber = (nextSlide / slick.slickGetOption('slidesToShow')) + 1;
            if (totalPages > 1) {
                $pageNumber.html('<span class="current">' + pageNumber + '</span>/' + totalPages);
            } else {
                $pageNumber.html('');
            }
        }
    };
};

$(document).ready(function() {
    $(window).on('resize orientationChange scroll', function() {
        data.doInitialiseSlickCarousels();
    });

    document.addEventListener('scroll', function() {
        const header = document.querySelector('body'); // Select your header element
        if (window.scrollY > 1) { // Adjust the scroll threshold (e.g., 50 pixels)
            header.classList.add('scroll'); // Add the 'scrolled' class
        } else {
            header.classList.remove('scroll'); // Remove the 'scrolled' class
        }
    });

    const currentUrl = window.location.href;
    document.querySelectorAll('.header-nav-list li a').forEach(link => {
        if (link.href === currentUrl) {
            link.parentElement.classList.add('current-page');
        }
    });

    function getAnchorOffset() {
        var cssOffset = parseFloat(getComputedStyle(document.body).getPropertyValue('--anchor-offset'));

        if (!isNaN(cssOffset)) {
            return cssOffset;
        }

        return 100;
    }

    // Smooth-scroll support for in-page anchors, specifically #contact
    function scrollToAnchor(hash) {
        if (!hash) return;
        var id = hash.replace('#', '');
        var $target = $('#' + id);
        if ($target.length) {
            $('html, body').animate({
                scrollTop: Math.max(0, $target.offset().top - getAnchorOffset())
            }, 600);
        }
    }

    // Click handler for links to #contact (or other anchors)
    $(document).on('click', 'a[href^="#"]', function (e) {
        var href = $(this).attr('href');
        if (href && href.indexOf('#') === 0) {
            var id = href.replace('#', '');
            if ($('#' + id).length) {
                e.preventDefault();
                scrollToAnchor(href);
                // Update history without jumping
                if (history.pushState) {
                    history.pushState(null, null, href);
                } else {
                    window.location.hash = href;
                }
            }
        }
    });

    // If the page loads with a hash (e.g., /page#contact), scroll to it
    if (window.location.hash) {
        setTimeout(function() {
            scrollToAnchor(window.location.hash);
        }, 50);
    }
});

var format = new function () {
    this.number = function (number, decimals, thousands_point) {
        if (number == null || !isFinite(number)) {
            throw new TypeError('number is not valid');
        }
        if (typeof decimals == 'undefined') {
            decimals = 2;
        }
        if (typeof thousands_point == 'undefined') {
            thousands_point = ',';
        }
        number = parseFloat(number).toFixed(decimals);

        var split_number = number.split('.');
        split_number[0] = split_number[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
        if (split_number[1]) {
            if (split_number[1].length < decimals) {
                split_number[1] += '0'.repeat(decimals);
            }
        } else {
            split_number[1] = '0'.repeat(decimals);
        }
        number = split_number.join('.');
        return number;
    };
    this.round = function (number) {
        return Math.round((number + Number.EPSILON) * 100) / 100;
    };
};
var printLoaded = false;
window.onbeforeprint = function(event) {

    if (!printLoaded) {
        $('head').append('<link href="/css/print.css" rel="stylesheet" media="print" />');
    }
};
